var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-partner"},[(_vm.processingRequest)?_c('v-progress-circular',_vm._b({staticClass:"mb-4"},'v-progress-circular',{
      size: '50',
      width: '4',
      indeterminate: true,
      color: 'secondary'
    },false)):_vm._e(),(!_vm.processingRequest && !_vm.requestResult)?[_c('v-icon',{staticClass:"mb-2",attrs:{"x-large":"","color":"red"}},[_vm._v(" mdi-alert-circle-outline ")]),_vm._v(" "+_vm._s(_vm.requestMessage)+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }